import { useDeleteSubstanceMutation, type Substances } from 'prove-common'
import { SubstanceForm } from '../../components/reference-data/ReferenceEntityForms'
import { ReferenceTable } from '../reference-table/ReferenceTable'

export const SubstancesTable = ({ substances }: { substances: Substances }) => {
  const remove = useDeleteSubstanceMutation()
  return (
    <ReferenceTable
      rows={substances}
      title='Substanser'
      emptyTitle='Ingen substanser'
      columns={[
        { key: 'name', label: 'Navn', value: (row) => row.name },
        { key: 'code', label: 'Kode', value: (row) => row.code },
        {
          key: 'displayname',
          label: 'Visningsnavn',
          value: (row) => row.displayname
        },
        { key: 'id', label: 'ID', value: (row) => row.id, copy: true }
      ]}
      name={(row) => row.name}
      editForm={(row, close) => (
        <SubstanceForm substance={row} onClose={close} />
      )}
      onDelete={(id) => remove.mutateAsync(id)}
    />
  )
}
